/* eslint-disable */
import React, { Component } from 'react'
import { render } from 'react-dom'
import _ from 'lodash'
import $ from 'jquery'
import { getParamsFromUrl } from './search/utils'
import appendIdToAccountLinks from './account'

class WishlistTrigger extends Component {
    constructor(props) {
        super(props)

        this.state = {
            inWishlist: this.props.inWishlist,
            displayError: false,
        }

        this.add = this.add.bind(this)
        this.remove = this.remove.bind(this)
        this.handleClick = this.handleClick.bind(this)
    }

    componentDidMount() {
        if (
            window.user !== undefined &&
            window.user.wishlist.includes(Number(this.props.propertyId))
        ) {
            this.setState({ inWishlist: true })
        } else {
            const addToWishlist = sessionStorage.getItem('addToWishlist')

            if (addToWishlist === String(this.props.propertyId)) {
                this.add()
                sessionStorage.removeItem('addToWishlist')
            }
        }
    }

    async add() {
        const { propertyId, propertyName, propertyType } = this.props
        try {
            const response = await fetch('/api/wishlist', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
                body: JSON.stringify({ propertyId }),
            })

            if (response.ok) {
                this.setState({ inWishlist: true })
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event: 'addToWishlist',
                    propertyType: _.capitalize(propertyType),
                    propertyName,
                })
            } else {
                console.log(response)
                this.setState({ displayError: true })
                window.setTimeout(
                    () => this.setState({ displayError: false }),
                    5000
                )
            }
        } catch (err) {
            console.log(err)
            this.setState({ displayError: true })
            window.setTimeout(
                () => this.setState({ displayError: false }),
                5000
            )
        }
    }

    async remove() {
        const { propertyId } = this.props
        try {
            const response = await fetch('/api/wishlist', {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
                body: JSON.stringify({ propertyId }),
            })

            if (response.ok) {
                this.setState({ inWishlist: false })
            } else {
                console.log(response)
                this.setState({ displayError: true })
                window.setTimeout(
                    () => this.setState({ displayError: false }),
                    5000
                )
            }
        } catch (err) {
            console.log(err)
            this.setState({ displayError: true })
            window.setTimeout(
                () => this.setState({ displayError: false }),
                5000
            )
        }
    }

    handleClick() {
        if (window.user === undefined) {
            $.magnificPopup.open({
                items: {
                    src: '#popup-create-account-wishlist',
                },
            })

            sessionStorage.setItem('addToWishlist', this.props.propertyId)
            appendIdToAccountLinks(this.props.propertyId)
        } else {
            this.add()
        }
    }

    render() {
        const { inWishlist, displayError } = this.state
        return (
            <div
                className="btn btn--full btn--thin btn--grey btn--ghost wishlist-trigger__btn"
                onClick={inWishlist ? this.remove : this.handleClick}
            >
                {inWishlist ? (
                    <span className="wishlist-trigger">
                        <span className="wishlist-trigger__icon is-active"></span>
                        Remove from Wishlist
                    </span>
                ) : (
                    <span className="wishlist-trigger">
                        <span className="wishlist-trigger__icon"></span>Add to
                        Wishlist
                    </span>
                )}

                <div
                    className={`alert alert--info alert--fixed ${displayError ? '' : 'is-hidden'}`}
                >
                    <p className="alert__text">
                        An error occured while trying to update your wishlist.
                        Please try again later.
                    </p>
                </div>
            </div>
        )
    }
}

function renderWishlistTrigger() {
    const triggers = Array.from(document.querySelectorAll('.js-wishlist'))
    triggers.forEach((trigger) => {
        const { propertyId, propertyName, propertyType, inWishlist } =
            trigger.dataset
        render(
            <WishlistTrigger
                propertyId={propertyId}
                propertyName={propertyName}
                propertyType={propertyType}
            />,
            trigger
        )
    })
}

export default renderWishlistTrigger()
